// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + "-" + "d2fd46c2442487c797a7" + ".bundle.css";
};